/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupSummaryDto { 
    id: string;
    type: GroupSummaryDto.TypeEnum;
    name: string;
    /**
     * Latest Git commit author for the group file, when available.
     */
    lastEditedBy?: string | null;
    /**
     * Date the group document was last modified, when available.
     */
    lastModified?: string | null;
    /**
     * Timestamp of the latest Git commit for the group file, when available.
     */
    commitTimestamp?: string | null;
    description?: string | null;
    icon?: string | null;
}
export namespace GroupSummaryDto {
    export const TypeEnum = {
        Group: 'group'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


